import Component from '../abstracts/Component';

export default class ShoppableComponent extends Component {

  get SELECTORS() {
    return {
      container: '.c-shoppable-content',
      main: '.js-shoppable-content',
      marker: '.js-marker',
      closeMarker: '.js-close-marker',
      markerContent: '.js-marker-content',
      wrapperItem: '.js-wrapper-shoppable-item',
      backdropMobile: '.js-backdrop-shoppable-content'
    }
  }

  get CLASSES() {
    return {
      active: 'active'
    }
  }

  constructor() {
    super();
    this.wrapper = $(this.SELECTORS.wrapperItem);
    this.container = $(this.SELECTORS.container);
    this.backdropMobile = $(this.SELECTORS.backdropMobile);
  }

  bindEvents(container) {
    let $container = $(container);
    let components = $container.find(this.SELECTORS.main);
    let _this = this;
    let $allmarkers = $container.find(this.SELECTORS.marker);

    // gestisco separatamente i wrapper desktop/mobile
    components.each((index, element) => {

      let currentContainer = $(element)
      let $markers = currentContainer.find(this.SELECTORS.marker);
      if ($markers.length) {
        $markers.each((index, element) => {

          $(element).click((e) => {
            // e.stopImmediatePropagation();
            let $marker = $(e.target);
            // for mobile
            if (window.innerWidth < 768) {
              $(_this.backdropMobile).addClass('visible');
            }
            if (!$marker.hasClass(_this.CLASSES.active)) {
              $allmarkers.removeClass(_this.CLASSES.active);
              let content = $marker.find(_this.SELECTORS.markerContent).clone();
              if (content) {

                let currentWrapper = currentContainer.find(_this.SELECTORS.wrapperItem);
                currentWrapper.fadeOut(300, ()=>{
                  currentWrapper.html(content);
                  currentWrapper.fadeIn(300);
                });
              }
              $marker.addClass(_this.CLASSES.active);
            }
          })

        })
      }
    });

    $('body').on('click', _this.SELECTORS.closeMarker, () => {
      _this.log('close shoppable-item');
      // for mobile
      if (window.innerWidth < 768) {
        $(_this.backdropMobile).removeClass('visible');
      }
      _this.wrapper.fadeOut(300, () => {
        _this.wrapper.html(' ');
      });
      $allmarkers.removeClass(_this.CLASSES.active);
    });

    window.addEventListener('resize', () => {
      if (this.$matchMedia('sm', null)) {
        $(_this.backdropMobile).removeClass('visible');
      }
    });
  }

  render() {

    if (this.container.length) {
      this.container.each((index, element) => {
        if (!$(element).hasClass('is-edit')) this.bindEvents(element);
      })
    }

  }
}
